module.exports = __webpack_public_path__ + "static/img/mypage-menu-icon01.8b8f479e.svg";